// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__PjVhE","text":"Button_text__1tg8Q","loader":"Button_loader__sGdrG","icon":"Button_icon__DJGKY"};